export default __webpack_public_path__ + "static/media/snd_00000.073388c5.mp4";